module.exports = __webpack_public_path__ + "static/media/icn_loan_amnt.e4cc1ee4.svg";